export default {
  hero: {
    badge: "Let's Talk",
    title: "Contact Us",
    subtitle: "Ready to take your business to the next level? Write to us and we'll reply in less than 24 hours."
  },
  info: {
    email: {
      label: "Email"
    },
    response: {
      label: "Response Time",
      value: "Less than 24 hours",
      days: "Monday to Friday"
    },
    service: {
      label: "Service",
      value: "Global — 100% Online",
      languages: "English & Spanish Support"
    }
  },
  social: {
    title: "Follow Us"
  },
  success: {
    title: "Message Sent!",
    subtitle: "Thank you for contacting us. We will reply in less than 24 hours.",
    cta: "Send another message"
  },
  form: {
    title: "Send Us a Message",
    subtitle: "Tell us about your project and we'll help you grow.",
    errors: {
      required: "Please fill in the required fields.",
      maxLength: "Message cannot exceed 500 characters."
    },
    fields: {
      name: { label: "Name", placeholder: "Your full name" },
      email: { label: "Email" },
      phone: { label: "Phone / WhatsApp" },
      service: { label: "Service of Interest", placeholder: "Select a service" },
      message: { label: "Message", placeholder: "Tell us about your business and how we can help..." }
    },
    cta: {
      sending: "Sending...",
      label: "Send Message"
    },
    services: {
      consulting: "Consulting & Strategy",
      other: "Other"
    }
  },
  calendar: {
    badge: "Book a Session",
    titlePrefix: "Reserve your ",
    titleHighlight: "Free Consultation",
    subtitle: "Schedule a 30-minute session with Cathy Roldán and discover how we can transform your digital business.",
    items: {
      i1: { title: "30 Minutes", desc: "Session focused on your goals" },
      i2: { title: "100% Online", desc: "Zoom or Google Meet" },
      i3: { title: "No Cost", desc: "First consultation is free" }
    },
    cta: "Book Free Consultation"
  }
};
